// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color, xScreen } from "@conklin/XDL/Utilities";
import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { css } from "styled-components";

customerSelectorToolbarStyles.wrapper = {
    css: css`
        display: flex;
        border-bottom: 1px solid ${color("common.border")};
        padding-bottom: 10px;
        column-gap: 10px;

        ${xScreen("lte", "sm")} {
            flex-wrap: wrap;
            gap: 10px;
        }
    `,
};

customerSelectorToolbarStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            flex-basis: 50%;
            ${xScreen("lte", "sm")} {
                flex-basis: 100%;
            }
        `,
        formInputWrapper: css`
            &&&& input {
                padding-right: 56px;
            }
        `,
    },
};

customerSelectorToolbarStyles.searchButton = {
    variant: "primary",
    css: css`
        margin-left: auto;
        flex-grow: 1;
    `,
};
